import { Api } from "@configs/api/api";
import apiConfig from "@configs/api/api.config";
import { cleanQueryParams } from "@helpers/index";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

//API ENDPOINT
// const API_UPLOAD_IMAGE = "/api/media/files/upload";
const API_UPLOAD_IMAGE = "/api/media/files/upload";
const API_DELETE_IMAGE = "/cms/api/media/acl/delete";
// const API_IMAGES = "/api/media/files";
const API_IMAGES = "/api/media/files";
//===============================================
class BaseApi extends Api {
  public constructor(config: AxiosRequestConfig) {
    super(config);
    this.uploadImage = this.uploadImage.bind(this);
    this.fetchImage = this.fetchImage.bind(this);
    this.saveImage = this.saveImage.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
    this.fetchBusinessImages = this.fetchBusinessImages.bind(this);
    this.uploadPublicImage = this.uploadPublicImage.bind(this);
    this.deleteMultipleFiles = this.deleteMultipleFiles.bind(this);
  }

  public fetchBusinessImages(businessId: string, params: any): Promise<any> {
    return this.get<any>(API_IMAGES, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("sid"),
        'x-role-context': 'admin',
        'x-business-id': businessId
      },
      params: cleanQueryParams(params),
    })
      .then((response: AxiosResponse<any>) => {
        const { data } = response;
        return data;
      })
      .catch((error: AxiosError) => {
        throw error;
      });
  }

  public uploadPublicImage(formData: any, onUploadProgress: Function, businessId: string): Promise<any> {
    return this.post<any>(API_UPLOAD_IMAGE, formData, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("sid"),
        'content-type': 'multipart/form-data',
        'x-role-context': 'admin',
        'x-business-id': businessId
      },
      onUploadProgress: (progressEvent: any) => {
        var percentCompleted = Math.floor(
          (progressEvent.loaded * 100) / (progressEvent.total || 1)
        );
        if (percentCompleted < 100) {
          onUploadProgress(percentCompleted);
        }
      },
    })
      .then((response: AxiosResponse<any>) => {
        const { data } = response;
        return data;
      })
      .catch((error: AxiosError) => {
        throw error;
      });
  }

  public deleteMultipleFiles(imageIds: string[], businessId: string): Promise<any> {
    return this.patch<any>(API_DELETE_IMAGE, JSON.stringify({
      "deleted": imageIds
    }), {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("sid"),
        'x-role-context': 'admin',
        'x-business-id': businessId
      },
    })
      .then((response: AxiosResponse<any>) => {
        const { data } = response;
        return data;
      })
      .catch((error: AxiosError) => {
        throw error;
      });
  }

  public fetchImage(params: any): Promise<any> {
    return this.get<any>(API_IMAGES, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("sid"),
        'x-role-context': 'admin'
      },
      params: cleanQueryParams(params),

    })
      .then((response: AxiosResponse<any>) => {
        const { data } = response;
        return data;
      })
      .catch((error: AxiosError) => {
        throw error;
      });
  }

  public uploadImage(formData: any, onUploadProgress: Function): Promise<any> {
    return this.post<any>(API_UPLOAD_IMAGE, formData, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("sid"),
        'content-type': 'multipart/form-data',
        'x-role-context': 'admin'
      },
      onUploadProgress: (progressEvent: any) => {
        var percentCompleted = Math.floor(
          (progressEvent.loaded * 100) / progressEvent?.total
        );
        if (percentCompleted < 100) {
          onUploadProgress(percentCompleted);
        }
      },
    })
      .then((response: AxiosResponse<any>) => {
        const { data } = response;
        return data;
      })
      .catch((error: AxiosError) => {
        throw error;
      });
  }

  public deleteImage(id: any): Promise<any> {
    return this.patch<any>(API_DELETE_IMAGE, JSON.stringify({
      "deleted": [id]
  }), {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("sid"),
        'x-role-context': 'admin'
      },
    })
      .then((response: AxiosResponse<any>) => {
        const { data } = response;
        return data;
      })
      .catch((error: AxiosError) => {
        throw error;
      });
  }

  public saveImage(formData: any, onUploadProgress: Function): Promise<any> {
    return this.post<any>(API_IMAGES, formData, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("sid"),
        'x-role-context': 'admin'

      },
      onUploadProgress: (progressEvent: any) => {
        var percentCompleted = Math.floor(
          (progressEvent.loaded * 100) / (progressEvent.total ||1)
        );
        if (percentCompleted < 100) {
          onUploadProgress(percentCompleted);
        }
      },
    })
      .then((response: AxiosResponse<any>) => {
        const { data } = response;
        return data;
      })
      .catch((error: AxiosError) => {
        throw error;
      });
  }
}

const baseApi = new BaseApi(apiConfig);
export default baseApi;
